import React from 'react';
import { Link } from 'react-router-dom';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import HeadingComponent from '../components/headingComponent/HeadingComponent';

import img1 from '../assets/searchbymenu/11.png';
import img2 from '../assets/searchbymenu/2.png';
import img3 from '../assets/searchbymenu/3.png';
import img4 from '../assets/searchbymenu/4.png';
import img5 from '../assets/searchbymenu/5.png';
import img6 from '../assets/searchbymenu/6.png';
import img7 from '../assets/searchbymenu/7.png';
import img8 from '../assets/searchbymenu/8.png';

import SolarExpert from './searchByMenuPages/SolarExpert';
import CenterLocator from './searchByMenuPages/CenterLocator';
import SolarEntrepreneur from './searchByMenuPages/SolarEntrepreneur';
import RoofTop from './searchByMenuPages/RoofTop';

const menuItems = [
	{ to: '/survey', img: img1, title: 'Solar Calculator' },
	{ to: '/survey', img: img2, title: 'Book Free Solar Site Survey' },
	{
		to: 'https://solarrooftop.gov.in',
		img: img3,
		title: 'Rooftop Solar Subsidy',
	},
	{ to: '/solarMart', img: img4, title: 'Solar Mart' },
	{
		to: '/rooftop',
		img: img5,
		title: 'Rooftop Solar Solution',
		element: <RoofTop />,
	},
	{
		to: '/solarExpert',
		img: img6,
		title: 'Ask Solar Expert',
		element: <SolarExpert />,
	},
	{
		to: '/solarEntrepreneur',
		img: img7,
		title: 'Be A Solar Entrepreneur',
		element: <SolarEntrepreneur />,
	},
	{
		to: '/centerLocator',
		img: img8,
		title: 'Solar Experience Centre Locator',
		element: <CenterLocator />,
	},
];

const SearchByMenu = () => {
	const goToTopBtn = () => {
		window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
	};

	return (
		<div className='container-fluid search_by_menu_container mb-5'>
			<HeadingComponent headerName={'Search By Menu'} />

			<div className='searchByMenu'>
				{menuItems.map((item, index) => (
					<div key={index} className='slideWrapper'>
						<Link to={item.to} target={item.target}>
							<LazyLoadImage
								src={item.img}
								alt='searchbymenu-Images'
								height='100px'
								onClick={goToTopBtn}
								style={{ margin: '0 auto' }}
							/>
							<h6 className='text-center my-2 search_by_menu_title'>{item.title}</h6>
						</Link>
					</div>
				))}
			</div>
		</div>
	);
};

export default SearchByMenu;
